import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { stripeNonSecretKey } from 'Consts/keys';
import 'Components/Modals/PaymentModal/index.css';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import segmentTypes from 'EventTracking/consts/segmentEvents';
import { FDBox } from '@facet-wealth/design';
import {
  PromoCodeInputContextProvider,
} from 'Context/PromoCodeInputContext';
import { LeadPropsContextProvider } from 'Context/LeadPropsContext';
import PaymentStepLayout from './PaymentStepLayout';
import { overrides } from './overrides';

const PaymentStepTemplate = ({
  resource,
}) => {
  const { setPageContentCollection } = usePageContentContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'payment', isPageView: true });
  const email = resource.attr('email');
  return (
    <div {...rootNodeProps} className="buyWizard">{/* Needed for the CSS for credit card inputs */}
      <StripeProvider apiKey={stripeNonSecretKey}>
        <Elements fonts={[{ family: 'Euclid Square', src: 'url(https://static.facetwealth.com/app/fonts/euclid-square-500-normal.otf)', weight: '500' }]}>
          <PromoCodeInputContextProvider>
            <LeadPropsContextProvider email={email}>
              <MetaFormInline
                LayoutProps={{ hideErrorList: true }}
                onChange={(attr, val) => {
                  if (attr === 'termsAndConditions' && val === 'true') logEvent(segmentTypes.leadCheckedTermsAndConditions, { email });
                  if (attr === 'memberAgreement' && val === 'true') logEvent(segmentTypes.leadCheckedMemberAgreement, { email });
                }}
                metaOverrideSet={overrides}
                component={FDBox/* Allows the background to be visible, removes padding */}
                resource={resource}
                layout={PaymentStepLayout}
                onSubmit={setPageContentCollection}
                noIndividualSubmitButtons
              />
            </LeadPropsContextProvider>
          </PromoCodeInputContextProvider>
        </Elements>
      </StripeProvider>
    </div>
  );
};

PaymentStepTemplate.defaultProps = {
};

PaymentStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PaymentStepTemplate;
